<!-- Поступление складского остатка: коробка со знаком плюс. -->
<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none"
    :stroke="stroke" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <path d="M3 7 10 3l7 4-7 4-7-4Z" />
    <path d="M3 7v9l7 4V11" />
    <path d="M17 7v5" />
    <path d="M15 18h6" />
    <path d="M18 15v6" />
  </svg>
</template>
<script>
export default {
  name: "StockReceiptIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
